<div class="challenge-card challenge-card--clean" (click)="!disableNavigation && navigateToDetail()" [class.disabled-navigation]="disableNavigation">
  <!-- Banner Image -->
  <div class="challenge-card--banner" [class.challenge-card--image-landscape]="useImageContain" [class.challenge-card--image-inherit]="useImageInherit">
    <img [src]="getImageUrl()" [alt]="data.name" loading="lazy" (load)="onImageLoad($event)" />
  </div>

  <!-- Content -->
  <div class="challenge-card--body">
    <h3 class="challenge-card--name">{{ data.name }}</h3>
    <p class="challenge-card--provider" *ngIf="data.provider">{{ data.provider }}</p>
    <div class="challenge-card--dates-row">
      <div class="challenge-card--dates" *ngIf="data.submissionStartsAt || data.submissionEndsAt" title="Submission period – when you can submit your solution">
        <svg class="challenge-card--dates-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span *ngIf="data.submissionStartsAt">{{ formatDisplayDate(data.submissionStartsAt) }}</span>
        <span class="challenge-card--dates-sep" *ngIf="data.submissionStartsAt && data.submissionEndsAt">–</span>
        <span *ngIf="data.submissionEndsAt">{{ formatDisplayDate(data.submissionEndsAt) }}</span>
      </div>
      <div class="challenge-card--days-left" [class.challenge-card--days-left-urgent]="isHoursLeft" [attr.title]="getDeadlineTooltip()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
        <span>{{ formatDaysRemaining(data.daysRemaining) }}</span>
      </div>
    </div>
    <p class="challenge-card--description" *ngIf="data.description && showDescription">{{ data.description }}</p>

    <!-- Compact Stats Row with inline arrow -->
    <div class="challenge-card--stats">
      <div class="challenge-card--stat" title="Number of participants who have joined or expressed interest">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <span>{{ data.participants }}</span>
      </div>
      <div class="challenge-card--stat" title="Number of submissions">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        <span>{{ data.submissions }}</span>
      </div>
      <div class="challenge-card--stat" title="Total prize amount for winners (cash or other rewards as specified)">
        <svg *ngIf="isUsdCurrency" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="1" x2="12" y2="23"></line>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
        </svg>
        <span class="challenge-card--prize">
          <span class="challenge-card--prize-symbol">{{ getPrizeSymbol() }}</span><span>{{ getPrizeAmount(data.prizeMoney) }}</span>
        </span>
      </div>
      <div class="challenge-card--action">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </div>
    </div>
  </div>
</div>
